module.exports = {
  '60f98deabb1d4f003c015d7c': require('./60f98deabb1d4f003c015d7c.json'),
  '60d3e737b1e04f3f24f7094f': require('./60d3e737b1e04f3f24f7094f.json'),
};
